module.exports = __webpack_public_path__ + "static/media/Supreme-X-The-North-Face-jacket_thumb.63ab28f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/mens/thumbs/Supreme-X-The-North-Face-jacket_thumb.png
// module id = 269
// module chunks = 0